// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  alleAuthConfig: {
      clientID: '__authClientID__',
      domain: '__authDomain__',
      responseType: 'token id_token',
      audience: '__authAudience__',
      redirectUri: '__authRedirectURI__',
      logoutUrl: '__logoutUrl__',
      scope: 'openid profile',
      inAppRedirects: {
          loggedIn: '/landing',
          error: '/'
      },
      silentAuthPage: '__authSilentAuth__'
  },
  profileConfig: {
    baseApiUrl: '__profileConfig__',
    whitelist: '__whitelistProfileConfig__'
  },
  portalAdminConfig: {
    baseApiUrl: '__portalAdminApiUrl__',
    whitelist: '__whitelistPortalAdminApiUrl__'
  },
  appInsights: {
    instrumentationKey: '__InstrumentationKey__',
    correlationDomains: '__correlationDomains__'
  },
  contactUrl: '__contactUrl__',
  launchpadUrl: '__launchpadUrl__',
  specialProgramUrl: '__specialProgramUrl__',
  helpUrl: '__helpUrl__',
  portalSupportEmail: '__portalSupportEmail__',
  thirdPartyNoticesFileUrl: "__thirdPartyNoticesFileUrl__"
};
